// Sparkles Small Icon SVG (16x16)
const sparklesSmallSvg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" height="16px" width="16px">
    <defs>
        <style>.cls-1{fill:currentColor;stroke-width:0px;}</style>
    </defs>
    <path
        class="cls-1"
        d="M8.7,7.3l3.8,1.47c.67.26.67,1.2,0,1.46l-3.8,1.47-1.47,3.8c-.26.67-1.2.67-1.46,0l-1.47-3.8-3.8-1.47c-.67-.26-.67-1.2,0-1.46l3.8-1.47,1.47-3.8c.26-.67,1.2-.67,1.46,0l1.47,3.8Z"
    />
    <path
        class="cls-1"
        d="M14.04,1.96l1.71.66c.35.13.35.62,0,.76l-1.71.66-.66,1.71c-.13.35-.62.35-.76,0l-.66-1.71-1.71-.66c-.35-.13-.35-.62,0-.76l1.71-.66.66-1.71c.13-.35.62-.35.76,0l.66,1.71Z"
    />
</svg>`;

const sparklesSmallIcon = {
    iconData: sparklesSmallSvg,
    iconWidth: 16,
    iconHeight: 16
};

export default sparklesSmallIcon;
